<ng-container *transloco="let t">

  <!--DEFAULT PAGE OPEN-->
  <div class="sub-main-containt {{theme}}" style="margin-top: 0px !important;" [style.font-family]="themeConfig.bgAndFontColor.default.font + ' !important'" [style.background]="setHeaderBackground(90, themeConfig.bgAndFontColor.default.bg[0], themeConfig.bgAndFontColor.default.bg[0])" [style.background-color]="themeConfig.bgAndFontColor.default.bg[0]">
    <div class="row p-0" style="height: 100%;">
      <div class="col-12 p-0 d-flex justify-content-center align-items-center" style="height: 100%;">
        <mat-card style="padding: 0px !important; min-width: 320px;">
          <div class="row box-ss py-3 mt-2" style="background-color: white;">
            @if (!loaded) {
              <div class="col-12 mb-3">
                <div style="display: flex; justify-content: center; align-items: center" class="w-100" [style.color]="themeConfig.bgAndFontColor.default.primary + ' !important'">
                  <mat-progress-spinner class="custom-spinner" color="warn" mode="indeterminate" [diameter]="100">
                  </mat-progress-spinner>
                </div>
              </div>
            }
            @if (loaded) {
              <div class="col-12 text-center  mt-3">
                @if (!isError) {
                  <img src="/assets/icons/success.png" alt="success" class="mb-3" style="width: 100px; height: 100px;">
                  <p class="p-0 text-success">{{ t('verifyAccount.verifiedSuccessfully') }}</p>
                }
                @if (isError) {
                  <img src="/assets/icons/error.png" alt="success" class="mb-3" style="width: 100px; height: 100px;">
                  <p class="p-0 text-danger">{{ t('verifyAccount.errorForVarification') }}</p>
                }
              </div>
            }

            @if (loaded) {
              <div class="col-12 text-center mt-3">
                <button mat-raised-button class="t-bg" style="height: 35px !important;" (click)="loginPage();" [style.background]="setHeaderBackground(90, themeConfig.bgAndFontColor.default.primaryBtn.bg[0], themeConfig.bgAndFontColor.default.primaryBtn.bg[0])" [style.background-color]="themeConfig.bgAndFontColor.default.primaryBtn.bg[0]" [style.color]="themeConfig.bgAndFontColor.default.primaryBtn.text" [style.font-family]="themeConfig.bgAndFontColor.default.font + '!important'">
                  {{ t('verifyAccount.visitHomePage') }}
                </button>
              </div>
            }

          </div>
        </mat-card>
      </div>
    </div>
  </div>
  <!--DEFAULT PAGE CLOSE-->

</ng-container>
